import React from 'react';
import ContentLoader from 'react-content-loader';
import './PanelDropOff.scss';

const PanelDropOffLoader = () => {
  return (
    <ContentLoader className="panel-transportations" height={180}>
      <rect className="placeholder-rect" />
    </ContentLoader>
  );
};

export default PanelDropOffLoader;



// WEBPACK FOOTER //
// ./src/components/molecules/PanelDropOff/PanelDropOffLoader.js